import styled from 'styled-components';

export const StyledLocalAccessLevelProfiles = styled.div`
    padding: 2rem;
`;
